import gql from 'graphql-tag';

export const DELETE_TEMPLATE = gql`
  mutation($templateId: Int!) {
    templates {
      delete(templateId: $templateId)
    }
  }
`;
